<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="dmca" />
  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section class="page-content">
        <h1>DMCA Policy</h1>
        
        <h2>Copyright Notification</h2>
        <p>GBWhatsApp respects intellectual property rights and expects our users to do the same. If you believe that your copyrighted work has been infringed, please send us a DMCA notice.</p>
        
        <h2>DMCA Notice</h2>
        <p>To file a copyright infringement notification with us, you will need to send a written communication that includes:</p>
        <ul>
          <li>A description of the copyrighted work</li>
          <li>Identification of the location of the copyrighted work</li>
          <li>Your contact information</li>
          <li>A statement of good faith belief</li>
          <li>A statement of accuracy under penalty of perjury</li>
        </ul>
        
        <h2>Counter Notification</h2>
        <p>If you believe your content was removed by mistake, you may submit a counter notification.</p>
        
        <h2>Contact</h2>
        <p>For DMCA requests, please contact us through our contact page.</p>
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Dmca',
  components: { HeadNav },
};
</script>

<style lang="scss" scoped>
.page-content {
  max-width: 1080px;
  margin: 2rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  h1 { color: #25D366; font-size: 2.5em; margin-bottom: 30px; }
  h2 { color: #25D366; font-size: 1.8em; margin: 30px 0 20px; }
  p, li { line-height: 1.8; font-size: 16px; color: #444; word-break: break-word; }
  ul { padding-left: 20px; }
  li { margin-bottom: 10px; }
}

@media (max-width: 768px) {
  .page-content {
    padding: 20px 15px;
    h1 { font-size: 2em; }
    h2 { font-size: 1.4em; }
    p, li { font-size: 15px; }
  }
}
</style>
